import { FC, HTMLAttributes } from 'react'

interface TotalPriceProps extends HTMLAttributes<HTMLDivElement> {
  label: string
  price: string
}

export const TotalPrice: FC<TotalPriceProps> = ({ label, price }) => {
  return (
    <div
      data-testid="total-to-pay"
      className="text-primary-base flex flex-col items-center self-start font-bold uppercase"
    >
      <p className="text-xs leading-6">{label}</p>
      <p data-testid="price-to-pay" className="text-2xl">
        {price}
      </p>
    </div>
  )
}
